import React, { useState, useEffect } from 'react';

const mockComments = [
    { username: '@sarah_fits', comment: 'Love how you styled this outfit! The color combo is perfect for spring 🌸', postLabel: 'Fashion Post', reason: 'She follows you and liked 3 of your posts — complimenting her unique color pairing' },
    { username: '@mike_travels', comment: 'This spot looks incredible! Adding it to my bucket list right now', postLabel: 'Travel Photo', reason: 'Active in #wanderlust, your target hashtag — showing genuine interest in the destination' },
    { username: '@chef_anna', comment: 'That plating is beautiful! Would love to know your secret ingredient', postLabel: 'Food Post', reason: 'Engaged with similar food creators — asking a question to spark conversation' },
    { username: '@yoga_daily', comment: 'Your form is so inspiring! How long did it take to nail this pose?', postLabel: 'Fitness Post', reason: 'Mutual followers in the fitness niche — encouraging her progress with curiosity' },
    { username: '@art_by_leo', comment: 'The brushwork here is stunning. You can really feel the emotion in every stroke', postLabel: 'Art Post', reason: 'He commented on your recent reel — acknowledging technique and emotional depth' },
];

// Direction cycle: right, left, right, right, left (repeating)
const swipeDirections: ('right' | 'left')[] = ['right', 'left', 'right', 'right', 'left'];

const SwipeReviewShowcase: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [swipeDirection, setSwipeDirection] = useState<'right' | 'left' | null>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            const dirIndex = currentIndex % swipeDirections.length;
            const direction = swipeDirections[dirIndex];
            setSwipeDirection(direction);
            setAnimating(true);

            setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % mockComments.length);
                setAnimating(false);
                setSwipeDirection(null);
            }, 600);
        }, 2500);

        return () => clearInterval(interval);
    }, [currentIndex]);

    const currentComment = mockComments[currentIndex];
    const nextComment = mockComments[(currentIndex + 1) % mockComments.length];

    return (
        <section style={{
            background: '#F7F7F7',
            padding: '120px 24px',
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                display: 'flex',
                alignItems: 'center',
                gap: '80px',
                flexWrap: 'wrap',
            }} className="swipe-showcase-container">
                {/* Text Column */}
                <div style={{ flex: '1 1 400px', minWidth: '300px' }}>
                    <h2 style={{
                        fontSize: 'clamp(32px, 5vw, 48px)',
                        fontWeight: 500,
                        color: '#000000',
                        marginBottom: '16px',
                        letterSpacing: '-0.02em',
                        lineHeight: 1.1,
                    }}>
                        Review comments like you swipe on Tinder
                    </h2>
                    <p style={{
                        fontSize: '18px',
                        color: '#7C3AED',
                        fontWeight: 600,
                        marginBottom: '32px',
                    }}>
                        Nothing gets posted until YOU say so
                    </p>
                    <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}>
                        <li style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#10B981',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.5">
                                    <polyline points="20,6 9,17 4,12" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontSize: '16px', fontWeight: 600, color: '#000000', marginBottom: '4px' }}>
                                    Swipe right to approve
                                </div>
                                <div style={{ fontSize: '15px', color: '#444444', lineHeight: 1.5 }}>
                                    Accept comments that match your voice and tone
                                </div>
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#EF4444',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.5">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontSize: '16px', fontWeight: 600, color: '#000000', marginBottom: '4px' }}>
                                    Swipe left to decline
                                </div>
                                <div style={{ fontSize: '15px', color: '#444444', lineHeight: 1.5 }}>
                                    Skip anything that doesn't feel right
                                </div>
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#6366F1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                    <line x1="12" y1="17" x2="12.01" y2="17" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontSize: '16px', fontWeight: 600, color: '#000000', marginBottom: '4px' }}>
                                    Know the reason behind every comment
                                </div>
                                <div style={{ fontSize: '15px', color: '#444444', lineHeight: 1.5 }}>
                                    Each comment comes with a clear reason explaining the AI's thinking
                                </div>
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#F59E0B',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontSize: '16px', fontWeight: 600, color: '#000000', marginBottom: '4px' }}>
                                    Edit to add your personal touch
                                </div>
                                <div style={{ fontSize: '15px', color: '#444444', lineHeight: 1.5 }}>
                                    Refine any AI-generated comment before it goes out
                                </div>
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#7C3AED',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                </svg>
                            </div>
                            <div>
                                <div style={{ fontSize: '16px', fontWeight: 600, color: '#000000', marginBottom: '4px' }}>
                                    Every comment is human-approved
                                </div>
                                <div style={{ fontSize: '15px', color: '#444444', lineHeight: 1.5 }}>
                                    Review on the train, walking, or during lunch — takes seconds
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                {/* Phone Demo Column */}
                <div style={{
                    flex: '0 0 auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    animation: 'phoneFloat 6s ease-in-out infinite',
                }} className="swipe-phone-wrapper">
                    {/* iPhone Frame */}
                    <div style={{
                        width: '300px',
                        height: '600px',
                        background: '#000000',
                        borderRadius: '40px',
                        padding: '12px',
                        position: 'relative',
                        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.3)',
                    }}>
                        {/* Notch */}
                        <div style={{
                            position: 'absolute',
                            top: '12px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '120px',
                            height: '28px',
                            background: '#000000',
                            borderRadius: '0 0 16px 16px',
                            zIndex: 10,
                        }} />

                        {/* Screen */}
                        <div style={{
                            width: '100%',
                            height: '100%',
                            background: '#FAFAFA',
                            borderRadius: '30px',
                            overflow: 'hidden',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                            {/* Status bar area */}
                            <div style={{
                                height: '48px',
                                background: '#FFFFFF',
                                borderBottom: '1px solid #E5E5E5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: '20px',
                            }}>
                                <span style={{
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#000000',
                                }}>
                                    Review Comments
                                </span>
                            </div>

                            {/* Card Stack Area */}
                            <div style={{
                                flex: 1,
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '16px',
                            }}>
                                {/* Background card (next card) */}
                                <div style={{
                                    position: 'absolute',
                                    width: 'calc(100% - 48px)',
                                    background: '#FFFFFF',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: '1px solid #E5E5E5',
                                    transform: 'scale(0.95) translateY(8px)',
                                    opacity: 0.6,
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        marginBottom: '12px',
                                    }}>
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        }} />
                                        <div>
                                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#000000' }}>
                                                {nextComment.username}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#999999' }}>
                                                {nextComment.postLabel}
                                            </div>
                                        </div>
                                    </div>
                                    <p style={{
                                        fontSize: '13px',
                                        color: '#333333',
                                        lineHeight: 1.5,
                                        margin: 0,
                                    }}>
                                        {nextComment.comment}
                                    </p>
                                </div>

                                {/* Active card */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: 'calc(100% - 48px)',
                                        background: '#FFFFFF',
                                        borderRadius: '12px',
                                        padding: '20px',
                                        border: '1px solid #E5E5E5',
                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                        animation: animating
                                            ? (swipeDirection === 'right' ? 'swipeRight 0.6s ease-out forwards' : 'swipeLeft 0.6s ease-out forwards')
                                            : 'cardSlideUp 0.3s ease-out',
                                        zIndex: 2,
                                    }}
                                >
                                    {/* Swipe overlay icon */}
                                    {animating && swipeDirection && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 3,
                                            animation: 'iconPop 0.3s ease-out',
                                        }}>
                                            {swipeDirection === 'right' ? (
                                                <div style={{
                                                    width: '56px',
                                                    height: '56px',
                                                    borderRadius: '50%',
                                                    background: '#10B981',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)',
                                                }}>
                                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3">
                                                        <polyline points="20,6 9,17 4,12" />
                                                    </svg>
                                                </div>
                                            ) : (
                                                <div style={{
                                                    width: '56px',
                                                    height: '56px',
                                                    borderRadius: '50%',
                                                    background: '#EF4444',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.4)',
                                                }}>
                                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3">
                                                        <line x1="18" y1="6" x2="6" y2="18" />
                                                        <line x1="6" y1="6" x2="18" y2="18" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        marginBottom: '12px',
                                    }}>
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                        }} />
                                        <div>
                                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#000000' }}>
                                                {currentComment.username}
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#999999' }}>
                                                {currentComment.postLabel}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Post thumbnail placeholder */}
                                    <div style={{
                                        width: '100%',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, #E8E8E8 0%, #D4D4D4 100%)',
                                        borderRadius: '8px',
                                        marginBottom: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#AAAAAA" strokeWidth="1.5">
                                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                            <circle cx="8.5" cy="8.5" r="1.5" />
                                            <polyline points="21,15 16,10 5,21" />
                                        </svg>
                                    </div>

                                    {/* Reason tag */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '6px',
                                        marginBottom: '8px',
                                    }}>
                                        <span style={{
                                            fontSize: '9px',
                                            fontWeight: 700,
                                            color: '#7C3AED',
                                            background: 'rgba(124, 58, 237, 0.08)',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.04em',
                                            flexShrink: 0,
                                            marginTop: '2px',
                                        }}>
                                            Reason
                                        </span>
                                        <span style={{
                                            fontSize: '11px',
                                            color: '#666666',
                                            lineHeight: 1.4,
                                        }}>
                                            {currentComment.reason}
                                        </span>
                                    </div>

                                    {/* Editable comment area */}
                                    <div style={{
                                        position: 'relative',
                                        background: '#F9FAFB',
                                        borderRadius: '8px',
                                        padding: '10px 32px 10px 10px',
                                        border: '1px solid #E5E5E5',
                                    }}>
                                        <p style={{
                                            fontSize: '12px',
                                            color: '#333333',
                                            lineHeight: 1.5,
                                            margin: 0,
                                        }}>
                                            {currentComment.comment}
                                        </p>
                                        {/* Edit pencil icon */}
                                        <div style={{
                                            position: 'absolute',
                                            top: '8px',
                                            right: '8px',
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            opacity: 0.4,
                                        }}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2">
                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bottom action hint */}
                            <div style={{
                                padding: '12px 16px 20px',
                                display: 'flex',
                                justifyContent: 'space-around',
                                alignItems: 'center',
                            }}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    border: '2px solid #EF4444',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2.5">
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </div>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    border: '2px solid #10B981',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5">
                                        <polyline points="20,6 9,17 4,12" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    @keyframes swipeRight {
                        0% { transform: translateX(0) rotate(0deg); opacity: 1; }
                        100% { transform: translateX(150px) rotate(15deg); opacity: 0; }
                    }
                    @keyframes swipeLeft {
                        0% { transform: translateX(0) rotate(0deg); opacity: 1; }
                        100% { transform: translateX(-150px) rotate(-15deg); opacity: 0; }
                    }
                    @keyframes iconPop {
                        0% { transform: translate(-50%, -50%) scale(0); }
                        60% { transform: translate(-50%, -50%) scale(1.2); }
                        100% { transform: translate(-50%, -50%) scale(1); }
                    }
                    @keyframes cardSlideUp {
                        0% { transform: scale(0.95) translateY(8px); opacity: 0.6; }
                        100% { transform: scale(1) translateY(0); opacity: 1; }
                    }
                    @keyframes phoneFloat {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-12px); }
                    }
                    @media (max-width: 768px) {
                        .swipe-showcase-container {
                            flex-direction: column !important;
                            gap: 48px !important;
                            text-align: center;
                        }
                        .swipe-phone-wrapper {
                            width: 100%;
                        }
                    }
                `}
            </style>
        </section>
    );
};

export default SwipeReviewShowcase;
